import type { SedrReportRecipient } from '../../api/sedr';

export type SedrReportRecipientKind = 'member' | 'guest' | 'external';

export function classifyReportRecipient(recipient: Pick<SedrReportRecipient, 'userId' | 'guestInviteId'>): SedrReportRecipientKind {
  if (recipient.userId) return 'member';
  if (recipient.guestInviteId) return 'guest';
  return 'external';
}

export interface SedrReportRecipientCounts {
  members: number;
  guests: number;
  externals: number;
  optedOut: number;
  activeTotal: number;
  total: number;
}

export function countReportRecipients(recipients: SedrReportRecipient[]): SedrReportRecipientCounts {
  const counts: SedrReportRecipientCounts = {
    members: 0,
    guests: 0,
    externals: 0,
    optedOut: 0,
    activeTotal: 0,
    total: recipients.length,
  };
  for (const recipient of recipients) {
    if (recipient.optedOut) {
      counts.optedOut += 1;
      continue;
    }
    counts.activeTotal += 1;
    const kind = classifyReportRecipient(recipient);
    if (kind === 'member') counts.members += 1;
    else if (kind === 'guest') counts.guests += 1;
    else counts.externals += 1;
  }
  return counts;
}
